import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=642ff576&scoped=true&"
import script from "./Recibo.vue?vue&type=script&lang=js&"
export * from "./Recibo.vue?vue&type=script&lang=js&"
import style0 from "./Recibo.vue?vue&type=style&index=0&id=642ff576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ff576",
  null
  
)

export default component.exports